// API Configuration based on environment
const isDevelopment = process.env.NODE_ENV === 'development';

const API_BASE_URL = isDevelopment 
  ? 'http://localhost:3000' 
  : '/api';

export const API_ENDPOINTS = {
  PRODUCTS: `${API_BASE_URL}/products`,
  BOOKINGS: `${API_BASE_URL}/bookings`,
  EVENTS: `${API_BASE_URL}/loadcalendrier`,
  LOADRESERVATION: `${API_BASE_URL}/loadReservation`,
  CONTACT: `${API_BASE_URL}/contact`,
  // Add other endpoints as needed
};

export default API_BASE_URL;